import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginCredentials, AccessToken, UserProfile } from '@models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthDataService {
  constructor(private _http: HttpClient) {}

  forgotPassword(email: string): Observable<void> {
    return this._http.post<void>('/auth/forgot-password', email);
  }

  resetPassword(password: string): Observable<void> {
    return this._http.post<void>('/auth/reset-password', password);
  }

  signInUsingToken(): Observable<AccessToken> {
    return this._http.post<AccessToken>('/login_sr.php?', {});
  }

  login(credentials: LoginCredentials): Observable<AccessToken> {
    return this._http.post<AccessToken>(`/login`, credentials);
  }

  getProfile(): Observable<UserProfile> {
    return this._http.get<UserProfile>(`/user-profile`);
  }

  signUp(user: { name: string; email: string; password: string; company: string }): Observable<void> {
    return this._http.post<void>('/auth/sign-up', user);
  }

  unlockSession(credentials: { email: string; password: string }): Observable<void> {
    return this._http.post<void>('/auth/unlock-session', credentials);
  }
}
